import makeStyles from '@mui/styles/makeStyles';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import FormikTextField from 'components/inputs/FormikTextField';
import Panel from 'components/Panel';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {LoginPayload} from 'types/auth';
import {useConnect} from '../redux/hooks/useConnect';
import ChangePasswordDialog from '../ChangePasswordDialog';
import Formik from 'components/hook-form/Formik';
import {useFormContext} from 'react-hook-form';
import {Divider} from '@mui/material';
import Button from 'components/Button';
import {useSSO} from '../redux/hooks/useSSO';
import {useCheckSSO} from '../redux/hooks/useCheckSSO';

type LoginFormProps = {
   userName?: string;
   allowChangeUser?: boolean;
};

const useStyles = makeStyles((theme) => ({
   form: {
      width: 400,
      margin: theme.spacing(0, 'auto'),
   },
   error: {
      textAlign: 'center',
   },
}));

const MainForm = ({userName = '', allowChangeUser}: LoginFormProps) => {
   const {t} = useTranslation();
   const classes = useStyles();
   const {
      formState: {isSubmitting},
   } = useFormContext();

   // const {} = useGetApi(api.)
   const ssoLogin = useSSO();
   const ssoAvailable = useCheckSSO();

   // const error = get(errors, 'errors.0.message.message');

   return (
      <Panel className={classes.form}>
         <FormikTextField
            autoFocus
            disabled={!allowChangeUser && Boolean(userName)}
            name="userName"
            label={t('Username')}
            InputProps={{
               autoFocus: true,
            }}
         />
         <FormikTextField type="password" name="password" label={t('Password')} />
         <PrimaryButton fullWidth type="submit" disabled={isSubmitting}>
            <Trans>Login</Trans>
         </PrimaryButton>
         {ssoAvailable && (
            <>
               <Divider />
               <Button fullWidth onClick={ssoLogin} style={{marginTop: '2rem'}}>
                  {t('SSO LOGIN')}
               </Button>
            </>
         )}
         {/* {error && (
            <FormHelperText className={classes.error} error>
               {error}
            </FormHelperText>
         )} */}
      </Panel>
   );
};

// If username passed outside then disable username input
const LoginForm = ({userName = '', allowChangeUser}: LoginFormProps) => {
   const {t} = useTranslation();
   // const error = useSelector(selectors.getLoginErrorMessage);
   const [login, expiredData, setExpired] = useConnect();

   return (
      <>
         <Formik
            initialValues={{
               userName,
               password: '',
            }}
            validate={(values) => {
               const errors = {} as LoginPayload;
               if (!values.userName) {
                  errors.userName = 'Required';
               }
               if (!values.password) {
                  errors.password = 'Required';
               }
               return errors;
            }}
            onSubmit={login}
         >
            <MainForm userName={userName} allowChangeUser={allowChangeUser} />
         </Formik>
         {expiredData ? (
            <ChangePasswordDialog
               onClose={() => {
                  setExpired(false);
               }}
               data={{
                  username: expiredData,
                  title: t('Your password has expired, please set a new one.'),
                  fromStartup: true,
               }}
            />
         ) : null}
      </>
   );
};

export default React.memo(LoginForm);
